<div class="info-dialog dialog-wrappers">
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">        
        <h1>Reference Documents</h1>
      </div>      
    </div>
    <div class="float-right">
      <!-- score-dialog <span class="close-dialog" mat-dialog-close><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span> -->
       <div  (click)="toggleMaximize()">
        <img class="maximize-btn" *ngIf="!isMaximized" src="../../../assets/images/Maximize_icon.png" alt="Maximize" title="Maximize">
        <img class="maximize-btn" *ngIf="isMaximized" src="../../../assets/images/Minimize_icon.png" alt="Minimize" title="Minimize">
      </div>
     </div>
   </div>

  <!-- <div class="maximize-wrapper">
    <div  (click)="toggleMaximize()">
      <img class="maximize-btn" *ngIf="!isMaximized" src="../../../assets/images/Maximize_icon.png" alt="Maximize" title="Maximize">
      <img class="maximize-btn" *ngIf="isMaximized" src="../../../assets/images/Minimize_icon.png" alt="Minimize" title="Minimize">
    </div>
  </div> -->
  <mat-dialog-content>
  <div class="padding-dialog">
    <ng-template #overlaptemplate>
      <mat-tab-group [(selectedIndex)]="selectedSubTabIndex">
        <mat-tab label="Response Overlap" *ngIf="roleName === 'SUPERVISOR' || true">
          <div class="similarity-score-wrapper">
            <span *ngIf="roleName === 'SUPERVISOR' && selectedTabIndex === 0" class="similarity-score">
              <span class="label">Similarity score:</span> {{currentScore}}
            </span>
          </div>
          <div class="response-overlap-content llm-response-section" *ngIf="selectedSubTabIndex === 0">
            <ng-container *ngIf="isLoading">
              <mat-spinner></mat-spinner>
            </ng-container>
            <markdown class="variable-binding" [data]="data"></markdown>
          </div>
        </mat-tab>
        <mat-tab label="Chunk Data" *ngIf="roleName === 'SUPERVISOR'">
          <div class="chunk-content-display llm-response-section" *ngIf="selectedSubTabIndex === 1">
            <markdown class="variable-binding" [data]="currentChunkText"></markdown>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-template>
    <mat-tab-group (selectedIndexChange)="onPageTabChange($event)" *ngIf="matchingIndices.length > 1">
      <mat-tab *ngFor="let match of matchingIndices; let localIndex = index" [label]="'Page ' + match.pageNumber"
        [class.single-page]="matchingIndices.length === 1">
        <ng-container *ngTemplateOutlet="overlaptemplate"></ng-container>
      </mat-tab>
    </mat-tab-group>

    <!-- For single tab -->
    <div *ngIf="matchingIndices.length === 1">
      <ng-container *ngTemplateOutlet="overlaptemplate"></ng-container>
    </div>
    <!-- End single tab -->
  </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()" class="btn-white btn-dialog-cancel">Close</button>
  </mat-dialog-actions>
</div>